import React, { useEffect, useRef, useState } from "react";
import { Alert } from "@mantine/core";
import {
  FaStar,
  FaBolt,
  FaFire,
  FaElementor,
  FaCircleExclamation,
} from "react-icons/fa6";
import Aside from "../../components/Aside/Aside";
import { Link } from "react-router-dom";
import Carousel from "../../components/Carousel/Carousel";
import InfoBlock from "./InfoBlock";
import TrendingProjects from "./TrendingProjects";
import BannerAds from "./BannerAds";
import ProjectsList from "./ProjectsList";
import PrelaunchProjects from "./PrelaunchProjects";
import KYCProjects from "./KYCProjects";
import HeaderProjects from "./HeaderProjects";
import projects from "../../utils/projects";
import { GoRocket } from "react-icons/go";
import { LuUserCheck } from "react-icons/lu";
import { getProjects } from "../../redux/features/projects/projectsSlice";

import { useDispatch, useSelector } from "react-redux";

const Projects = ({ toggleColorScheme, computedColorScheme, isWideScreen }) => {
  const dispatch = useDispatch();
  const {
    projects: newProjects,
    totalCount,
    totalPages,
    currentPage,
    limit,
    totalMarketCapUsd,
  } = useSelector((state) => state.projects.projects);
  const [isScrolled, setIsScrolled] = useState(false);

  const handleScroll = () => {
    // Check if the page is scrolled, you can adjust the threshold as needed
    const scrolled = window.scrollY > 0;

    // Update the state based on the scroll position
    setIsScrolled(scrolled);
  };

  useEffect(() => {
    // Attach the scroll event listener when the component mounts
    window.addEventListener("scroll", handleScroll);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []); // Empty dependency array ensures the effect runs only once on mount

  // open search
  const [searchOpen, setSearchOpen] = useState(false);

  const searchTrendingRef = useRef(null);

  const handleSearchOpen = () => {
    setSearchOpen(true);
  };

  // pagination
  const [isOpenPagination, setIsOpenPagination] = useState(false);
  const [selectedRows, setSelectedRows] = useState(30);

  const openPagination = () => {
    setIsOpenPagination(!isOpenPagination);
  };

  const paginationRef = useRef(null);

  const handleRowSelection = (rows) => {
    setSelectedRows(rows);
    setIsOpenPagination(false); // Close the pagination after selecting rows
    dispatch(getProjects({ page: 1, limit: rows }));
  };

  const handleProjectsPage = (page) => {
    dispatch(getProjects({ page: page, limit: limit }));
  };

  const handleClickOutside = (event) => {
    if (
      paginationRef.current &&
      !paginationRef.current.contains(event.target)
    ) {
      // Click outside the pagination, close it
      setIsOpenPagination(false);
    }

    if (
      searchTrendingRef.current &&
      !searchTrendingRef.current.contains(event.target)
    ) {
      // Click outside the pagination, close it
      setSearchOpen(false);
    }
  };

  useEffect(() => {
    // Add event listener when the component mounts
    document.addEventListener("click", handleClickOutside);

    // Remove event listener when the component unmounts
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const [isSearchMobile, setIsSearchMobile] = useState(false);
  const handleSearchMobile = () => {
    setIsSearchMobile(!isSearchMobile);
  };

  // alert icon
  const alertIcon = <FaCircleExclamation />;
  return (
    <>
      <div className="min-w-0 flex-1 pb-[4.75rem] sm:pb-16 sm:px-8 px-4 2xl:px-16 mx-auto max-w-screen-2xl">
        <HeaderProjects
          searchOpen={searchOpen}
          handleSearchOpen={handleSearchOpen}
          searchTrendingRef={searchTrendingRef}
          isScrolled={isScrolled}
          toggleColorScheme={toggleColorScheme}
          computedColorScheme={computedColorScheme}
          isSearchMobile={isSearchMobile}
          setIsSearchMobile={setIsSearchMobile}
          handleSearchMobile={handleSearchMobile}
          projects={newProjects}
        />
        <div
          className={`grid grid-cols-12 gap-6 text-neutral-100 dark:text-neutral-0 sm:gap-8 ${
            isWideScreen ? "content-wide" : ""
          } ${isSearchMobile ? "hidden" : ""}`}
        >
          <div className="col-span-12 lg:col-span-4 lg:row-span-1 md:hidden xs:hidden lg:flex xl:flex">
            <InfoBlock
              totalMarketCapUsd={totalMarketCapUsd}
              totalCount={totalCount}
            />
          </div>
          <div className="col-span-12 lg:col-span-8">
            <div className="flex h-full flex-col gap-4">
              <div className="flex flex-wrap items-center justify-between gap-1">
                <div className="flex flex-wrap items-center gap-2 gap-y-0">
                  <div className="flex items-center gap-1">
                    <FaStar className="text-xl" style={{ color: "#FFD700" }} />
                    <Link
                      to=""
                      className="whitespace-nowrap font-semibold text-neutral-100 dark:text-neutral-0 text-base sm:text-xl pointer-events-auto"
                    >
                      Promoted Projects
                    </Link>
                  </div>
                </div>
                <div className="flex items-center text-xs">
                  Your project here? Contact us!
                </div>
              </div>
              <Carousel
                projects={newProjects}
                autoSlide={true}
                isLarge={true}
              />
            </div>
          </div>

          <div className="col-span-12 lg:col-span-12">
            <TrendingProjects projects={newProjects} />
          </div>
          {/* <div className="col-span-12 lg:col-span-7">
            <div className="flex h-full flex-col gap-4">
              <div className="flex flex-wrap items-center justify-between gap-1">
                <div className="flex flex-wrap items-center gap-2 gap-y-0">
                  <div className="flex items-center gap-1">
                    <Link
                      to=""
                      className="whitespace-nowrap font-semibold text-neutral-100 dark:text-neutral-0 text-base sm:text-xl pointer-events-auto"
                    >
                      Latest Projects Audited
                    </Link>
                  </div>
                </div>
                <div className="flex items-center gap-1"></div>
              </div>
              <Carousel projects={newProjects} isLarge={false} />
            </div>
          </div>

          <div className="col-span-12 lg:col-span-5 lg:row-span-1 flex items-end">
            <BannerAds />
          </div> */}
          <div className="col-span-12 xl:col-span-12 md:col-span-12 lg:row-span-2">
            <div className="flex items-center justify-content-end xl:justify-content-between mb-2 ">
              <div className="hidden lg:flex xl:flex flex-grow">
                <Alert
                  variant="light"
                  color="blue"
                  title="Projects ranked based on daily views, priority to those with audits!"
                  icon={alertIcon}
                  className="mr-4 py-1 rounded rounded-lg"
                />
              </div>

              <div className="flex items-center text-xs">
                Your project here? Contact us!
              </div>
            </div>
            <ProjectsList
              projects={newProjects}
              selectedRows={selectedRows}
              handleRowSelection={handleRowSelection}
              isOpenPagination={isOpenPagination}
              openPagination={openPagination}
              paginationRef={paginationRef}
              totalCount={totalCount}
              totalPages={totalPages}
              currentPage={currentPage}
              limit={limit}
              handleProjectsPage={handleProjectsPage}
            />
          </div>
          {/* <div className="col-span-12 lg:col-span-12 xl:col-span-4">
            <PrelaunchProjects projects={newProjects} />
            <KYCProjects projects={newProjects} />
          </div> */}
        </div>
      </div>
      <div className="block sm:hidden">
        <div className="fixed bottom-0 left-0 z-fixed w-screen px-2 transition-transform grid grid-cols-5 justify-between gap-1  bg-black-90 backdrop-blur-md dark:bg-neutral-100/80 shadow-xl-reverse shadow-black-5 dark:shadow-black-20 text-neutral-0">
          <div
            className={`relative flex flex-col items-center justify-center gap-1.5 py-2.5 text-2xs  ${
              !isSearchMobile ? "font-medium" : "font-semibold text-neutral-30"
            }`}
          >
            <div
              className={`absolute left-1 right-1 top-0 h-1 ${
                !isSearchMobile ? "bg-primary-main" : ""
              }`}
            ></div>
            <FaBolt className="text-xl" />
            Dashboard
          </div>
          <div
            className="relative flex flex-col items-center justify-center gap-1.5 py-2.5 text-2xs font-medium text-neutral-30"
            role="button"
            tabindex="0"
          >
            <div className="absolute left-1 right-1 top-0 h-1 bg-transparent"></div>
            <GoRocket className="text-xl" />
            Projects
          </div>
          <div
            className="relative flex flex-col items-center justify-center gap-1.5 py-2.5 text-2xs font-medium text-neutral-30"
            role="button"
            tabindex="0"
          >
            <div className="absolute left-1 right-1 top-0 h-1 bg-transparent"></div>
            <FaFire className="text-xl" />
            PreLaunch
          </div>
          <div
            className="relative flex flex-col items-center justify-center gap-1.5 py-2.5 text-2xs font-medium text-neutral-30"
            role="button"
            tabindex="0"
          >
            <div className="absolute left-1 right-1 top-0 h-1 bg-transparent"></div>
            <LuUserCheck className="text-xl" />
            KYC Verified
          </div>
          <div className="relative flex flex-col items-center justify-center gap-1.5 px-2 py-2.5 text-2xs font-normal text-neutral-40">
            <FaElementor className="text-xl" />
            More
          </div>
        </div>
      </div>
    </>
  );
};

export default Projects;
